import { render, staticRenderFns } from "./caseLibrary.vue?vue&type=template&id=3c19907c&scoped=true"
import script from "./caseLibrary.vue?vue&type=script&lang=js"
export * from "./caseLibrary.vue?vue&type=script&lang=js"
import style0 from "./caseLibrary.vue?vue&type=style&index=0&id=3c19907c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19907c",
  null
  
)

export default component.exports